/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ListFilterPlus = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M10 18h4" }],
    ["path", { d: "M11 6H3" }],
    ["path", { d: "M15 6h6" }],
    ["path", { d: "M18 9V3" }],
    ["path", { d: "M7 12h8" }]
  ]
];

export { ListFilterPlus as default };
//# sourceMappingURL=list-filter-plus.js.map
